export const CONSTANTS = {
  Fifteen: 15,
};
